import InlineEditable from './InlineEditable';
export default InlineEditable;
